import React from 'react';
import { Box, Skeleton } from '@mui/material';

interface FormSkeletonProps {
  fields?: number;
  additionalFields?: boolean;
}

export const FormSkeleton = ({ 
  fields = 2,
  additionalFields = false 
}: FormSkeletonProps = {}) => (
  <Box sx={{ p: 3 }}>
    {/* Título */}
    <Skeleton variant="text" width={200} height={40} sx={{ mb: 4 }} />

    {/* Campos principais */}
    {Array.from({ length: fields }).map((_, index) => (
      <Skeleton 
        key={index}
        variant="rectangular" 
        height={56} 
        sx={{ mb: 2, borderRadius: 1 }} 
      />
    ))}

    {/* Área de campos adicionais */}
    {additionalFields && (
      <>
        <Skeleton variant="text" width={150} height={32} sx={{ mt: 4, mb: 2 }} />
        <Skeleton variant="rectangular" height={200} sx={{ mb: 2, borderRadius: 1 }} />
      </>
    )}

    {/* Botões */}
    <Box sx={{ mt: 4, display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
      <Skeleton variant="rectangular" width={100} height={36} sx={{ borderRadius: 1 }} />
      <Skeleton variant="rectangular" width={100} height={36} sx={{ borderRadius: 1 }} />
    </Box>
  </Box>
); 